import { render, staticRenderFns } from "./FeedbackTableview.vue?vue&type=template&id=c916c046&scoped=true"
import script from "./FeedbackTableview.vue?vue&type=script&lang=js"
export * from "./FeedbackTableview.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTableview.vue?vue&type=style&index=0&id=c916c046&prod&lang=scss&scoped=true"
import style1 from "./FeedbackTableview.vue?vue&type=style&index=1&id=c916c046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c916c046",
  null
  
)

export default component.exports